import React, { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import AppShell from "../../components/AppShell";
import { api, formatErr } from "../../lib/api";
import { btn } from "../../components/leads/PriorityBadge";
import { LibraryTab } from "../../components/testlib/LibraryTab";
import { AssignTab } from "../../components/testlib/AssignTab";
import { ReviewTab } from "../../components/testlib/ReviewTab";
import { ProgressTab } from "../../components/testlib/ProgressTab";
import { OverviewTab } from "../../components/testlib/OverviewTab";
import { RemindersTab } from "../../components/testlib/RemindersTab";

export default function AdminTestLibrary() {
  const [tab, setTab] = useState("overview");
  const [lib, setLib] = useState([]);
  const [archived, setArchived] = useState(false);
  const [clients, setClients] = useState([]);
  const [review, setReview] = useState([]);
  const loadLib = useCallback(() => api.get(`/admin/test-library?include_archived=${archived}`).then((r) => setLib(r.data)).catch((e) => toast.error(formatErr(e))), [archived]);
  const loadReview = useCallback(() => api.get("/admin/test-assignments?state_filter=needs_review").then((r) => setReview(r.data)).catch((e) => toast.error(formatErr(e))), []);
  useEffect(() => { loadLib(); }, [loadLib]);
  useEffect(() => { loadReview(); api.get("/admin/clients").then((r) => setClients(r.data)).catch(() => {}); }, [loadReview]);
  const TABS = [["overview", "Resumen"], ["library", `Biblioteca (${lib.length})`], ["assign", "Asignar y seguimiento"], ["review", `Revisión (${review.length})`], ["progress", "Progreso"], ["reminders", "Recordatorios"]];
  return (
    <AppShell>
      <div data-testid="admin-test-library">
        <h1 style={{ fontFamily: "Bebas Neue, sans-serif", fontSize: "2rem", letterSpacing: "0.06em", margin: 0 }}>Biblioteca de tests</h1>
        <p style={{ color: "#a3a3a3", fontSize: 13, margin: "4px 0 16px" }}>Tus fichas de test, qué hace cada futbolista y los resultados por revisar. La IA no asigna ni cambia tests.</p>
        <div style={{ display: "flex", gap: 6, marginBottom: 16, flexWrap: "wrap" }}>
          {TABS.map(([k, l]) => <button key={k} style={btn(tab === k ? "#dc2626" : "transparent")} onClick={() => { setTab(k); if (k === "review") loadReview(); }} data-testid={`tl-tab-${k}`}>{l}</button>)}
        </div>
        {tab === "overview" && <OverviewTab />}
        {tab === "reminders" && <RemindersTab />}
        {tab === "library" && <LibraryTab items={lib} reload={loadLib} showArchived={archived} setShowArchived={setArchived} />}
        {tab === "assign" && <AssignTab library={lib} clients={clients} />}
        {tab === "progress" && <ProgressTab clients={clients} />}
        {tab === "review" && <ReviewTab items={review} reload={() => { loadReview(); loadLib(); }} />}
      </div>
    </AppShell>
  );
}
